export default __webpack_public_path__ + "static/media/LOGO_CCCC.722957ca.jpeg";